import { render } from "./EmojisKit.vue?vue&type=template&id=0aaba28f"
import script from "./EmojisKit.vue?vue&type=script&lang=js"
export * from "./EmojisKit.vue?vue&type=script&lang=js"

import "./EmojisKit.vue?vue&type=style&index=0&id=0aaba28f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__